import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import {
    Box,
    Sheet,
    Typography,
    Button,
    Stack,
    Avatar,
    Dropdown,
    MenuButton,
    Menu,
    MenuItem,
    IconButton,
} from '@mui/joy';
import {
    Logout,
    Person,
    Dashboard as DashboardIcon,
} from '@mui/icons-material';

const Layout = ({ children }) => {
    const { profile, logout } = useAuth();
    const navigate = useNavigate();

    const handleLogout = () => {
        logout();
        navigate('/login');
    };

    const handleDashboard = () => {
        navigate('/admin');
    };

    return (
        <Box sx={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
            {/* Header */}
            <Sheet
                sx={{
                    p: 2,
                    borderBottom: '1px solid',
                    borderColor: 'divider',
                    backgroundColor: 'background.surface',
                }}
            >
                <Stack
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                    sx={{ maxWidth: '1400px', mx: 'auto', width: '100%' }}
                >
                    {/* Left side - Logo/Title */}
                    <Stack direction="row" alignItems="center" spacing={2}>
                        <IconButton
                            variant="soft"
                            color="primary"
                            onClick={handleDashboard}
                            sx={{ borderRadius: '50%' }}
                        >
                            <DashboardIcon />
                        </IconButton>
                        <Box>
                            <Typography level="h4" sx={{ mb: 0 }}>
                                AiHub Admin
                            </Typography>
                            <Typography level="body-xs" textColor="neutral.500">
                                Administration Panel
                            </Typography>
                        </Box>
                    </Stack>

                    {/* Right side - User menu */}
                    <Stack direction="row" alignItems="center" spacing={2}>
                        {profile && (
                            <Box sx={{ display: { xs: 'none', sm: 'block' } }}>
                                <Typography level="body-sm" textAlign="right">
                                    {profile.name}
                                </Typography>
                                <Typography level="body-xs" textColor="neutral.500" textAlign="right">
                                    {profile.email}
                                </Typography>
                            </Box>
                        )}
                        
                        <Dropdown>
                            <MenuButton
                                slots={{ root: IconButton }}
                                slotProps={{ root: { variant: 'outlined', color: 'neutral' } }}
                            >
                                <Avatar size="sm">
                                    <Person />
                                </Avatar>
                            </MenuButton>
                            <Menu placement="bottom-end">
                                <MenuItem disabled>
                                    <Stack>
                                        <Typography level="body-sm" fontWeight="bold">
                                            {profile?.name || 'Admin'}
                                        </Typography>
                                        <Typography level="body-xs" textColor="neutral.500">
                                            {profile?.email || 'admin@example.com'}
                                        </Typography>
                                    </Stack>
                                </MenuItem>
                                <MenuItem onClick={handleLogout} color="danger">
                                    <Logout sx={{ mr: 1 }} />
                                    Logout
                                </MenuItem>
                            </Menu>
                        </Dropdown>
                    </Stack>
                </Stack>
            </Sheet>

            {/* Main Content */}
            <Box component="main" sx={{ flex: 1 }}>
                {children}
            </Box>
        </Box>
    );
};

export default Layout; 